export let baseurl = "https://growmaxbackend.ogcs.co.in";
//  export let baseurl = "http://localhost:8000";
//  export let baseurl = "http://localhost:5001";
